// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__3LO2x","header":"Messages_header__2zgNL"};